import PropTypes from 'prop-types';

const propTypes = {
  src: PropTypes.string,
  srcSet: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  fetchpriority: PropTypes.string,
  customAttributes: PropTypes.object,
  loading: PropTypes.string,
  onClick: PropTypes.func
};

const Img = ({
  src = '',
  srcSet = null,
  alt = null,
  width = null,
  height = null,
  className = null,
  style = null,
  fetchpriority = 'auto',
  customAttributes = {},
  loading = 'lazy',
  onClick
}) => (
  <img
    src={src}
    srcSet={srcSet}
    alt={alt}
    style={style}
    width={width}
    height={height}
    className={className}
    fetchpriority={fetchpriority}
    {...customAttributes}
    loading={loading}
    onClick={onClick}
  />
);

Img.propTypes = propTypes;

export default Img;
